import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';


const UserIdsSection = ({ onUpdate, boostInput = false, fields = ['user_id', 'user_name'] }) => {
  const [currentUserIds, setCurrentUserIds] = useState('');
  const [boost, setBoost] = useState(1);
  const [userFieldType, setUserFieldType] = useState(fields[0]);

  const handleUserAction = (actionType) => {
    if (!currentUserIds.trim()) return;
    
    const userIdsArray = currentUserIds.split(',').map(id => id.trim()).filter(id => id);
    if (userIdsArray.length === 0) return;
    
    const updateData = {
      action: actionType,
      filter: 'terms',
      field: userFieldType,
      value: userIdsArray
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    setCurrentUserIds(''); // Reset after adding
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>User Field Type</InputLabel>
        <Select
          value={userFieldType}
          onChange={(e) => setUserFieldType(e.target.value)}
          label="Field"
        >
          {fields.map(field => (
            <MenuItem key={field} value={field}>
              {field.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <TextField
        label={userFieldType.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
        value={currentUserIds}
        onChange={(e) => setCurrentUserIds(e.target.value)}
        placeholder="Enter comma-separated ids"
        helperText="e.g., 123, 456, 789, john, alice, bob"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleUserAction('include')}
          disabled={!currentUserIds.trim()}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleUserAction('boost')}
            disabled={!currentUserIds.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleUserAction('exclude')}
          disabled={!currentUserIds.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default UserIdsSection;

